export default "__VITE_ASSET__Du9jtFmr__"